module.exports = __webpack_public_path__ + "static/media/wix.13482582.svg";